// Will be combined in the refactored part

import { LocalStorageLanguageProperty } from "../entities/Language";
import { LocalStorageService } from "../services/LocalStorageService";

export const getCurrentLanguageId = () => {
  // TODO: US english creates some problems id 14
  const languageFromLocalStorage = LocalStorageService.getItem(
    LocalStorageLanguageProperty.LANGUAGE_ID,
  );
  const languageToBeSet =
    languageFromLocalStorage && typeof languageFromLocalStorage === "string"
      ? languageFromLocalStorage
      : "35";

  return parseFloat(languageToBeSet);
};
